import React from "react";
import { useHistory } from "react-router-dom";
import { BackIcon } from "../assets/Icons";

const BackBtn = () => {
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
  };

  return (
    <span className="backbtn" onClick={handleBack} style={{ cursor: "pointer" }}>
      <BackIcon />
    </span>
  );
};

export default BackBtn;
